/** Matches api-medpharma RegistrationPlatform for users signing up via the mCare web app. */
export const REGISTRATION_PLATFORM_MCARE = "mcare" as const;
